import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { TPublishersResponse, TPublish, } from "./types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import PublishreApi from "../../api/publisher-api";
import { VIPER_CONST } from "../../commonConstant";
import { IThemeUpdate } from "../../types";

type TPublisher = {
  publisher: { data: TPublish[] | null };
  loading: boolean;
  auth: boolean;
  status: number | null;
  statusMessage: string;
};

const initialState: TPublisher = {
  publisher: {
    data: null,
  },
  loading: false,
  auth: true,
  status: null,
  statusMessage: "",
};

const publish = createAsyncThunk(
  "publisher/get",
  async (request: IThemeUpdate, thunkApi) => {
    try {
      const requestData = await PublishreApi.PublishApi(request);
      return thunkApi.fulfillWithValue(requestData);
    } catch (error: any) {
      console.error("No response:", error);
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const publishButton = createAsyncThunk(
  "publish/getOne",
  async (request: IThemeUpdate, thunkApi) => {
    try {
      const requestData = await PublishreApi.UpdateApi(request);
      console.log(`API Response: ${VIPER_CONST.base_url}updatetheme`, requestData);
      return thunkApi.fulfillWithValue({ ...requestData, ...request });
    } catch (error: any) {
      console.error("No response:", error);
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const rejectButton = createAsyncThunk(
  "publish/delete",
  async (request: IThemeUpdate, thunkApi) => {
    try {
      const requestData = await PublishreApi.UpdateApi(request);
      console.log(`API Response: ${VIPER_CONST.base_url}updatetheme`, requestData);
      return thunkApi.fulfillWithValue({ ...requestData, ...request });
    } catch (error: any) {
      console.error("No response:", error);
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const PublisherSlice = createSlice({
  name: "Get Publisher Data",
  initialState,
  reducers: {
    clearAuth: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(publish.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(publish.fulfilled, (state, action) => {
      state.loading = false;
      state.auth = true;
      // console.log("Fulfilled action payload:", action.payload);
      const response = action.payload as TPublishersResponse;
      state.publisher.data = response.data.themes || null;
    });
    builder.addCase(publish.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(publishButton.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(publishButton.fulfilled, (state, action) => {
      state.loading = false;
      state.status = action?.payload?.status ?? null;
      state.statusMessage = action?.payload?.statusMessage ?? "";
    });
    builder.addCase(publishButton.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(rejectButton.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(rejectButton.fulfilled, (state, action) => {
      state.loading = false;
      state.status = action?.payload?.status ?? null;
      state.statusMessage = action?.payload?.statusMessage ?? "";
    });
    builder.addCase(rejectButton.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const { clearAuth } = PublisherSlice.actions;

export { publish, publishButton, rejectButton };

export const auth = (state: RootState) => state.publish.auth;
export const loading = (state: RootState) => state.publish.loading;
export const publisherStatusData = (state: RootState) => state.publish.status;
export default PublisherSlice.reducer;
